const featureToggles = {
  emails: false,
  recipes: true,
}

export default featureToggles
